import { createAction, props } from '@ngrx/store';
import { DataMM07 } from '../../models/criterions/DataMM07';
import { DataMM07Part } from '../../models/criterions/DataMM07Part';
import { DataMM07NioshPart } from '../../models/criterions/DataMM07NioshPart';
import { NioshSlipResistence } from '../../models/criterions/NioshSlipResistence';
import { Analysis } from '../../models/Analysis';
import { SystemError } from '../../../shared/models/SystemError';

export enum ActionTypes {
    UPDATE_DATA_MM07 = '[CR07 Page] Update DataMM 07 on Analysis state',
    UPDATE_DATA_MM07_AND_RECALC = '[CR07 Page] Update DataMM 07 on Analysis state and recalculate analysis',
    UPDATE_ACTIVE_PART = '[CR07 Page] Update active part on DataMM07 state',
    UPDATE_ACTIVE_PART_AND_RECALC_SUCCESS = '[CR07 Page] Update active part on DataMM07 state and recalculate analysis success',
    UPDATE_ACTIVE_PART_AND_RECALC = '[CR07 Page] Update active part on DataMM07 state and recalculate analysis',
    UPDATE_ACTIVE_PART_AND_RECALC_FAIL = '[CR07 Page] Update active part on DataMM07 state and recalculate analysis fail',
    DELETE_MM07_FORCE_CASE_AND_RECALC = '[CR07 Page] Delete force case and recalculate analysis',
    DELETE_MM07_FORCE_CASE_AND_RECALC_SUCCESS = '[CR07 Page] Delete force case and recalculate analysis success',
    DELETE_MM07_FORCE_CASE_AND_RECALC_FAIL = '[CR07 Page] Delete force case and recalculate analysis fail',
    ADD_NEW_NIOSH_PART_TO_TABLE = '[CR07 Page] Add new NIOSH part to table',
    UPDATE_FIELD_OF_NIOSH_PART = '[CR07 Page] Update field of NIOSH part',
    DUPLICATE_NIOSH_PART = '[CR07 Page] Duplicate NIOSH part',
    DELETE_NIOSH_PART = '[CR07 Page] Delete NIOSH part',
    OPEN_FORCE_CASE_POPUP = '[CR07 Page] Open force case popup',
    OPEN_FORCE_CASE_POPUP_AND_RECALC = '[CR07 Page] Open force case popup and recalculate analysis',
    OPEN_FORCE_CASE_POPUP_AND_UPDATE_DATA = '[CR07 Page] Open force case popup and update DataMM07',
    CLOSE_FORCE_CASE_POPUP = '[CR07 Page] Close force case popup',
    CLOSE_FORCE_CASE_POPUP_AND_RESET_NO_STRESS = '[CR07 Page] Close force case popup and reset no stress',
    ADD_PART_TO_DATA_MM07 = '[CR07 Page] Add part to DataMM07',
    ADD_PART_TO_DATA_MM07_SUCCESS = '[CR07 Page] Add part to DataMM07 success',
    ADD_PART_TO_DATA_MM07_FAIL = '[CR07 Page] Add part to DataMM07 fail',
    VALIDATE_MM07_LOAD_WEIGHT = '[CR07 Page] Validate MM07 load weight',
    VALIDATE_MM07_LOAD_WEIGHT_SUCCESS = '[CR07 Page] Validate MM07 load weight success',
    DUPLICATE_MM07_PART_AND_RECALC = '[CR07 Page] Duplicate part to DataMM07 and call recalc'
}

export const updateDataMM07 = createAction(ActionTypes.UPDATE_DATA_MM07, props<{ dataMM07: DataMM07 }>());

export const updateDataMM07AndRecalc = createAction(ActionTypes.UPDATE_DATA_MM07_AND_RECALC, props<{ dataMM07: DataMM07 }>());

export const updateDataMM07ActivePart = createAction(ActionTypes.UPDATE_ACTIVE_PART, props<{ activePart: DataMM07Part | null }>());

export const updateMM07ActivePartAndRecalc = createAction(ActionTypes.UPDATE_ACTIVE_PART_AND_RECALC, props<{ activePart: DataMM07Part | null }>());

export const updateMM07ActivePartAndRecalcSuccess = createAction(
    ActionTypes.UPDATE_ACTIVE_PART_AND_RECALC_SUCCESS,
    props<{ activePart: DataMM07Part | null }>()
);

export const updateMM07ActivePartAndRecalcFail = createAction(ActionTypes.UPDATE_ACTIVE_PART_AND_RECALC_FAIL, props<{ systemError: SystemError }>());

export const deleteMM07ForceCaseAndRecalc = createAction(ActionTypes.DELETE_MM07_FORCE_CASE_AND_RECALC, props<{ dataMM07: DataMM07 }>());

export const deleteMM07ForceCaseAndRecalcSuccess = createAction(
    ActionTypes.DELETE_MM07_FORCE_CASE_AND_RECALC_SUCCESS,
    props<{ analysis: Analysis; message: string }>()
);

export const deleteMM07ForceCaseAndRecalcFail = createAction(ActionTypes.DELETE_MM07_FORCE_CASE_AND_RECALC_FAIL, props<{ systemError: SystemError }>());

export const addNewNioshPartToTable = createAction(ActionTypes.ADD_NEW_NIOSH_PART_TO_TABLE, props<{ nioshPart: DataMM07NioshPart }>());

export const updateNioshPartField = createAction(
    ActionTypes.UPDATE_FIELD_OF_NIOSH_PART,
    props<{ nioshPart: DataMM07NioshPart; field: string; value: string | number | NioshSlipResistence }>()
);

export const duplicateNioshPart = createAction(ActionTypes.DUPLICATE_NIOSH_PART, props<{ nioshPart: DataMM07NioshPart }>());

export const deleteNioshPart = createAction(ActionTypes.DELETE_NIOSH_PART, props<{ nioshPart: DataMM07NioshPart }>());

export const openForceCasePopupMM07 = createAction(ActionTypes.OPEN_FORCE_CASE_POPUP);

export const openForceCasePopupMM07AndRecalc = createAction(ActionTypes.OPEN_FORCE_CASE_POPUP_AND_RECALC, props<{ dataMM07: DataMM07 }>());

export const openForceCasePopupMM07AndUpdateData = createAction(ActionTypes.OPEN_FORCE_CASE_POPUP_AND_UPDATE_DATA, props<{ dataMM07: DataMM07 }>());

export const closeForceCasePopupMM07 = createAction(ActionTypes.CLOSE_FORCE_CASE_POPUP);

export const closeForceCasePopupMM07AndResetNoStress = createAction(ActionTypes.CLOSE_FORCE_CASE_POPUP_AND_RESET_NO_STRESS);

export const addPartToDataMM07 = createAction(ActionTypes.ADD_PART_TO_DATA_MM07, props<{ dataMM07: DataMM07 }>());

export const addPartToDataMM07Success = createAction(ActionTypes.ADD_PART_TO_DATA_MM07_SUCCESS, props<{ analysis: Analysis; message: string }>());

export const addPartToDataMM07Fail = createAction(ActionTypes.ADD_PART_TO_DATA_MM07_FAIL, props<{ systemError: SystemError }>());

export const validateMM07LoadWeight = createAction(ActionTypes.VALIDATE_MM07_LOAD_WEIGHT, props<{ activePart: DataMM07Part }>());

export const validateMM07LoadWeightSuccess = createAction(ActionTypes.VALIDATE_MM07_LOAD_WEIGHT_SUCCESS);

export const duplicateMM07PartAndRecalc = createAction(ActionTypes.DUPLICATE_MM07_PART_AND_RECALC, props<{ dataMM07: DataMM07 }>());
